// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Loading } from '../../containers/Loading';
import { Plus } from '../../containers/Plus';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { SearchBar } from '../../containers/SearchBar';
import { getStickers, deleteSticker, uploadSticker} from '../../state/actions/StickerActions';
import { StickerCreationModal } from '../../modals/StickerCreationModal';

import { StickerList } from './StickerList';

// COMPONENT
class StickerPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            stickers: [],
            filteredForSearch: [],
            createModal: false,
            deleteModal: false,
            searchInput: ''
        };
        
        this.deleteItem = this.deleteItem.bind(this);
        this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
        this.toggleCreateModal = this.toggleCreateModal.bind(this);
        this.uploadSticker = this.uploadSticker.bind(this);
        this.delete = this.delete.bind(this);
        this.searchInputChanged = this.searchInputChanged.bind(this);
    }

    componentDidMount(){
        this.props.getStickers();

        this.setState({
            stickers: this.props.stickers
        }, 
        function () {
            this.searchInputChanged(this.state.searchInput);
        }
        );
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.stickers) !== JSON.stringify(prevProps.stickers)) {
            this.setState({ stickers: this.props.stickers });
            this.searchInputChanged(this.state.searchInput);
        }

        if (this.props.uploadingSticker !== prevProps.uploadingSticker) {
            this.setState({ uploadingSticker: this.props.uploadingSticker });
        }

        if (this.props.uploadedSticker !== prevProps.uploadedSticker) {

            if (this.props.uploadedSticker && prevProps.uploadingSticker) {
                this.props.getStickers;
                this.toggleCreateModal();
            }

            this.setState({ uploadedSticker: this.props.uploadedSticker });
        }

        if (this.props.failedStickers !== prevProps.failedStickers) {
            this.setState({ failedStickers: this.props.failedStickers });
        }
    }

    deleteItem(stickerID){
        this.selectedstickerID = stickerID;
        this.toggleDeleteModal();
    }

    uploadSticker(metaData, files) {
        this.props.uploadSticker(metaData, files);
    }

    delete(){
        this.toggleDeleteModal();
        var stickersToDelete = this.props.stickers.find(item => {
            return item.id === this.selectedstickerID;
        });
        this.props.deleteSticker(stickersToDelete);
    }

    toggleDeleteModal() {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    }

    toggleCreateModal() {
        this.setState({
            createModal: !this.state.createModal
        });
    }

    searchInputChanged(input){
        if(input == ''){
            this.setState({
                filteredForSearch: this.state.stickers,
                searchInput: input
            });
        } else {
            var filteredForSearch = [];
            let searchComponents = input.split(' ');
            for(let sticker of this.state.stickers){
                var doesContainAllSearchComponents = true;
                for(let searchItem of searchComponents){
                    if(!sticker.name.toLowerCase().includes(searchItem.toLowerCase())){
                        doesContainAllSearchComponents = false;
                    }
                }

                if (doesContainAllSearchComponents) {
                    filteredForSearch.push(sticker);
                }
            }
            this.setState({
                filteredForSearch: filteredForSearch,
                searchInput: input
            });
        }
    }

    render() {
        return (
            <Fragment>
                <div className="page-title">Stickers</div>
                <SearchBar inputChanged={this.searchInputChanged}/>
                <div> 
                    <div className='plus-wrapper' onClick={this.toggleCreateModal}> 
                        <Plus/>
                    </div>
                    { this.props.fetchedStickers && <StickerList deleteItem={this.deleteItem} stickers={this.state.filteredForSearch} /> }
                    { this.props.fetchingStickers && (<Loading/>) }
                    { this.props.failedStickers && (<div>{'Couldn\'t fetch products.'}</div>) }
                </div>

                <Modal isOpen={this.state.deleteModal} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>Delete Sticker</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this sticker?
                    </ModalBody>
                    <ModalFooter>
                        <Button className="button" color="secondary" onClick={this.toggleDeleteModal}>Cancel</Button>
                        <Button className="button" color="danger" onClick={this.delete}>Delete</Button>{' '}
                    </ModalFooter>
                </Modal>
                <StickerCreationModal isOpen={this.state.createModal} toggleCreateModal={this.toggleCreateModal} uploadSticker={this.uploadSticker} />
            </Fragment>
        );
    }
}

StickerPage.propTypes = {
    stickers: PropTypes.array.isRequired,
    fetchingStickers: PropTypes.bool.isRequired,
    fetchedStickers: PropTypes.bool.isRequired,
    failedStickers: PropTypes.bool.isRequired,
    uploadingSticker: PropTypes.bool.isRequired,
    uploadedSticker: PropTypes.bool.isRequired,
    getStickers: PropTypes.func.isRequired,
    deleteSticker: PropTypes.func.isRequired,
    uploadSticker: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { stickers, fetchingStickers, fetchedStickers, failedStickers, uploadedSticker, uploadingSticker } = state.stickerReducer;
    return { stickers, fetchingStickers, fetchedStickers, failedStickers, uploadedSticker, uploadingSticker };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getStickers, deleteSticker, uploadSticker}, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(StickerPage));

// EXPORT COMPONENT

export { hoc as StickerPage };


// WEBPACK FOOTER //
// ./src/components/pages/Stickers/StickerPage.js